const USD_CURRENCY_FORMATTER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

const roundUp = (value, decimals = 2) => {
  if (!Number.isFinite(value)) return null;
  const factor = 10 ** decimals;
  return Math.ceil(value * factor) / factor;
};

const toNumber = (value) => {
  if (Number.isFinite(value)) return value;
  if (typeof value === "string") {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

const formatPercent = (value, options = {}) => {
  const {
    decimals = 2,
    withSign = false,
    normalize = false,
    zeroAs = null,
    fallback = "-",
  } = options;
  const num = Number(value);
  if (!Number.isFinite(num)) return fallback;
  const adjusted = normalize && Math.abs(num) <= 1 ? num * 100 : num;
  if (adjusted === 0 && zeroAs !== null && zeroAs !== undefined) {
    return zeroAs;
  }
  const sign = withSign && adjusted > 0 ? "+" : "";
  return `${sign}${adjusted.toFixed(decimals)}%`;
};

const formatCurrency = (value, formatter = USD_CURRENCY_FORMATTER, fallback = "-") => {
  const num = Number(value);
  if (!Number.isFinite(num)) return fallback;
  return formatter.format(num);
};

const formatCurrencyShort = (value, unitOverride = null, decimals = 2) => {
  if (!Number.isFinite(value)) return "-";
  const abs = Math.abs(value);
  const unit = unitOverride || (abs >= 1_000_000_000 ? "B" : "M");
  const divisor = unit === "B" ? 1_000_000_000 : 1_000_000;
  const rounded = roundUp(value / divisor, decimals);
  if (rounded === null) return "-";
  return `$${rounded.toFixed(decimals)}${unit}`;
};

const formatCurrencyPlain = (value, decimals = 2) => {
  if (!Number.isFinite(value)) return "-";
  const rounded = roundUp(value, decimals);
  if (rounded === null) return "-";
  const digits = Number.isInteger(rounded) ? 0 : decimals;
  return `$${rounded.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
};

const formatCurrencyKOnly = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "-";
  const sign = num < 0 ? "-" : "";
  const abs = Math.abs(num);
  if (abs >= 1_000) {
    const scaled = (abs / 1_000).toFixed(1).replace(/\.0$/, "");
    return `${sign}$${scaled}K`;
  }
  return `${sign}$${abs.toFixed(2).replace(/\.?0+$/, "")}`;
};

export {
  formatCurrencyKOnly,
  roundUp,
  toNumber,
  formatPercent,
  formatCurrency,
  formatCurrencyShort,
  formatCurrencyPlain,
};
